import Head from 'next/head';
import Footer24 from '@/components/organisms/Footer24';
import Header24 from '@/components/organisms/Header24';

import { EmprestimoGarantiaTabs } from '@/data/misc/EmprestimoGarantiaTabs';
import React, { useState } from 'react';
import CustomTabs from '../CustomTabs';

import Styles from './TabGroupEmprestimoGarantia.css';
import FaqLPs25 from '../FaqLPs25';
import EmprestimoGarantiaCarroBanner from '@/components/organisms/EmprestimoGarantiaCarroBanner';
import EmprestimoGarantiaCarroCondicoes from '@/components/organisms/EmprestimoGarantiaCarroCondicoes';
import EmprestimoGarantiaCarroBlog from '@/components/organisms/EmprestimoGarantiaCarroBlog';
import EmprestimoGarantiaCarro from '@/components/templates/EmprestimoGarantiaCarro';
import EmprestimoGarantiaCarroContrato from '@/components/templates/EmprestimoGarantiaCarroContrato';
import BancoDoAutoModalDisclaimer from '@/components/organisms/BancoDoAutoModalDisclaimer';
import EmprestimoGarantiaCarroBannerAbr26 from '@/components/organisms/EmprestimoGarantiaCarroBannerAbr26';

function TabGroupEmprestimoGarantia({ tab }) {
  const [currentTab, setCurrentTab] = useState(tab);

  const handleTab = (id) => {
    setCurrentTab(id);
  };

  const faqTitle = 'Perguntas frequentes sobre empréstimo com garantia de veículo';
  const imgpng =
    currentTab === EmprestimoGarantiaTabs['emprestimo-garantia'].id
      ? 'assets/emprestimo-garantia-carro/img-perguntas.png'
      : 'assets/emprestimo-garantia-carro-contrato/img-perguntas.png';
  const imgwebp =
    currentTab === EmprestimoGarantiaTabs['emprestimo-garantia'].id
      ? 'assets/emprestimo-garantia-carro/img-perguntas.webp'
      : '';
  const imgpngdesk =
    currentTab === EmprestimoGarantiaTabs['emprestimo-garantia'].id
      ? 'assets/emprestimo-garantia-carro/img-perguntas-desk.png'
      : 'assets/emprestimo-garantia-carro-contrato/img-perguntas-desk.png';
  const imgwebpdesk =
    currentTab === EmprestimoGarantiaTabs['emprestimo-garantia'].id
      ? 'assets/emprestimo-garantia-carro/img-perguntas-desk.webp'
      : 'assets/emprestimo-garantia-carro-contrato/img-perguntas-desk.webp';
  const imgalt =
    currentTab === EmprestimoGarantiaTabs['emprestimo-garantia'].id
      ? 'Casal pesquisando em tablet e computador sobre modalidade de empréstimo com garantia de veículo pela Santander Financiamentos.'
      : 'Pessoa com camisa vermelha com notebook e papeis, observando no site da Santander Financiamentos seu contrato de empréstimo.';
  // const linkMostrarTodasPerguntas = 'duvidas-frequentes.html'; exemplo quando tem "Mostrar todas as perguntas"
  const faqs = [
    {
      pergunta: 'O que é empréstimo com garantia de veículo?',
      resposta: `O empréstimo com garantia de veículo, também conhecido como refinanciamento
        de veículo, é uma modalidade de crédito em que você utiliza um carro quitado
        como garantia do contrato. O veículo continua no seu nome e pode ser usado
        normalmente durante o pagamento das parcelas, ficando apenas alienado à
        instituição financeira até a quitação da dívida. Como o risco da operação é
        menor, essa modalidade costuma oferecer taxas de juros mais baixas, prazos
        maiores e limites de crédito mais altos do que um empréstimo pessoal
        tradicional.`,
    },
    {
      pergunta: 'Como funciona o empréstimo com garantia de veículo?',
      resposta: `O empréstimo com garantia de veículo funciona utilizando um carro quitado
        como garantia da operação. Após a solicitação, o Santander realiza a análise
        de crédito e a avaliação do veículo. Se aprovado, o veículo permanece com o
        proprietário, ficando apenas alienado até a quitação da dívida.`,
    },
    {
      pergunta: 'Posso fazer empréstimo com garantia de veículo estando negativado?',
      resposta: `Não. Para contratar um empréstimo com garantia de veículo no Santander, é
        necessário atender aos critérios da análise de crédito da instituição.
        Atualmente, clientes com restrições no CPF não podem contratar essa
        modalidade.`,
    },
    {
      pergunta: 'Qual o valor máximo que posso conseguir?',
      resposta: `O valor do empréstimo pode chegar a até R$ 200 mil, conforme a análise de
        crédito, a avaliação do veículo e as condições de contratação do Santander.`,
    },
    {
      pergunta: 'Posso fazer empréstimo com carro financiado?',
      resposta: `Não. O veículo precisa estar quitado, em nome do solicitante e atender aos
        critérios de contratação do Santander para ser utilizado como garantia do
        empréstimo.`,
    },
    {
      pergunta: 'Vale a pena fazer um empréstimo com garantia de veículo?',
      resposta: `Sim. O empréstimo com garantia de veículo pode valer a pena para quem busca
        crédito com taxas de juros menores, prazos maiores e possibilidade de
        contratar valores mais altos. Antes de contratar, avalie as condições
        oferecidas e certifique-se de que as parcelas caibam no seu orçamento.`,
    },
  ];

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map(({ pergunta, resposta }) => ({
      '@type': 'Question',
      name: pergunta,
      acceptedAnswer: {
        '@type': 'Answer',
        text: resposta.replace(/\s+/g, ' ').trim(),
      },
    })),
  };

  const financialProductSchema = {
    '@context': 'https://schema.org',
    '@type': 'FinancialProduct',
    name: 'Empréstimo com Garantia de Veículo',
    provider: {
      '@type': 'Organization',
      name: 'Santander Financiamentos',
    },
  };
  return (
    <>
      <Head>
        <title>Empréstimo com Garantia de Veículo | Simule Online</title>
        <meta
          name="Description"
          content="Consiga crédito com seu veículo em garantia. Taxas a partir de 1,39% a.m., até 60 parcelas, aprovação na hora e contratação simples. Simule agora!"
        />
        <link
          rel="canonical"
          href="https://www.santander.com.br/hotsite/santanderfinanciamentos/emprestimo-garantia-carro.html"
        />
        <link
          rel="preload"
          as="image"
          type="image/webp"
          fetchpriority="high"
          href="assets/emprestimo-garantia-carro/hero-abr-26/banner-800.webp"
          imageSrcSet="assets/emprestimo-garantia-carro/hero-abr-26/banner-312.webp 312w, assets/emprestimo-garantia-carro/hero-abr-26/banner-450.webp 450w, assets/emprestimo-garantia-carro/hero-abr-26/banner-600.webp 600w, assets/emprestimo-garantia-carro/hero-abr-26/banner-800.webp 800w, assets/emprestimo-garantia-carro/hero-abr-26/banner-1280.webp 1280w, assets/emprestimo-garantia-carro/hero-abr-26/banner-1920.webp 1920w, assets/emprestimo-garantia-carro/hero-abr-26/banner-2650.webp 2650w"
          imageSizes="100vw"
        />
        <meta name="robots" content="index, follow" />
        <meta
          name="keywords"
          content="Empréstimo com garantia de veículo, Crédito com garantia de veículo, Financiamento com garantia de veículo, Empréstimo com veículo em garantia, Empréstimo usando carro como garantia, Simulação de empréstimo, Dinheiro rápido, Contratação online, Documentação necessária, Como funciona o empréstimo com garantia de veículo, Valor do empréstimo, Taxas de juros baixas, Aprovação facilitada, Empréstimo com garantia de veículo para pessoa Jurídica, Empréstimo com garantia de veículo para pessoa física"
        />
        {/* <!-- OPEN GRAPH TAGS FOR FACEBOOK, WHATSAPP AND LINKEDIN --> */}
        <meta property="og:locale" content="pt_BR" />
        <meta property="og:title" content="Empréstimo com Garantia de Veículo | Simule Online" />
        <meta
          property="og:url"
          content="https://www.santander.com.br/hotsite/santanderfinanciamentos/emprestimo-garantia-carro.html"
        />
        <meta property="og:site_name" content="Santander Financiamentos" />
        <meta
          property="og:description"
          content="Consiga crédito com seu veículo em garantia. Taxas a partir de 1,39% a.m., até 60 parcelas, aprovação na hora e contratação simples. Simule agora!"
        />
        <meta
          property="og:image"
          content="https://www.santander.com.br/hotsite/santanderfinanciamentos/assets/emprestimo-garantia-carro/hero/hero-1440.webp"
        />
        <meta
          property="og:image:alt"
          content="Casal feliz com as chaves no carro após realizarem um empréstimo com garantia de veículo no Santander."
        />
        <meta property="og:image:type" content="image/webp" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="627" />
        <meta property="og:type" content="website" />
        {/* <!-- TWITTER CARDS FOR TWITTER --> */}
        <meta name="twitter:card" content="" />
        <meta name="twitter:title" content="Empréstimo com Garantia de Veículo | Simule Online" />
        <meta
          name="twitter:description"
          content="Consiga crédito com seu veículo em garantia. Taxas a partir de 1,39% a.m., até 60 parcelas, aprovação na hora e contratação simples. Simule agora!"
        />
        <meta
          name="twitter:url"
          content="https://www.santander.com.br/hotsite/santanderfinanciamentos/emprestimo-garantia-carro.html"
        />
        <meta
          property="twitter:image"
          content="https://www.santander.com.br/hotsite/santanderfinanciamentos/assets/emprestimo-garantia-carro/hero/hero-1440.webp"
        />
        <meta
          property="twitter:image:alt"
          content="Casal feliz com as chaves no carro após realizarem um empréstimo com garantia de veículo no Santander."
        />
        <meta property="twitter:image:type" content="image/webp" />
        <meta property="twitter:image:width" content="1200" />
        <meta property="twitter:image:height" content="627" />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify([faqSchema, financialProductSchema]),
          }}
        />
      </Head>
      <Header24 isHome24 hideAreaCliente />
      {/* <EmprestimoGarantiaCarroBanner currentTab={currentTab} /> */}
      <EmprestimoGarantiaCarroBannerAbr26 />
      {/* <BancoDoAutoModalDisclaimer notModal /> */}

      <CustomTabs
        initialTab={tab}
        tabs={EmprestimoGarantiaTabs}
        onTabChanged={handleTab}
        allowQueryParamCompare
      />

      <EmprestimoGarantiaCarro
        show={currentTab === EmprestimoGarantiaTabs['emprestimo-garantia'].id}
      />

      <EmprestimoGarantiaCarroContrato
        show={currentTab === EmprestimoGarantiaTabs['emprestimo-garantia-contrato'].id}
      />

      {/* <EmprestimoGarantiaCarroCondicoes /> */}
      <FaqLPs25
        imgpng={imgpng}
        imgwebp={imgwebp}
        imgpngdesk={imgpngdesk}
        imgwebpdesk={imgwebpdesk}
        imgalt={imgalt}
        faqtitle={faqTitle}
        faqs={faqs}
        // linkMostrarTodasPerguntas={linkMostrarTodasPerguntas}
      />
      <EmprestimoGarantiaCarroBlog />
      <Footer24 />
      <style jsx>{Styles}</style>
    </>
  );
}

export default TabGroupEmprestimoGarantia;
